import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1579.95 1387.02C1572.53 1519.42 1513.62 1648.22 1429.38 1759.63L1344.05 1696.16C1419.79 1596 1467.54 1486.79 1473.46 1381.16 1479.27 1277.42 1445.11 1173 1349.01 1077.68L1424.42 1002.88C1541.63 1119.13 1587.47 1252.74 1579.95 1387.02zM1918.83 1413.75C1907.82 1593.17 1820.33 1768.26 1694.57 1920.15L1612.15 1853.01C1728.94 1711.95 1803.16 1557.47 1812.37 1407.33 1821.43 1259.62 1768.07 1110.03 1617.4 973.552L1689.32 895.438C1862.06 1051.91 1929.98 1231.89 1918.83 1413.75z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M106.657 105.935H533.283C709.974 105.935 853.253 248.072 853.253 423.369V786.462H959.91V423.369C959.91 248.096 1103.17 105.935 1279.88 105.935H1706.51V649.004H1813.16V0.147949H1279.88C1119.24 0.147949 979.341 88.2059 906.566 218.309C833.783 88.2148 693.898 0.147949 533.283 0.147949H0V1631.52H362.782V1525.73H106.657V105.935Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M814.549 1139.33L1071.24 884.726H1199.99V1904.31L1071.24 1904.31L798.232 1633.53H543.994V1139.33H814.549ZM1093.33 1012.42L858.728 1245.11H650.65V1527.74H842.411L1093.33 1776.62V1012.42Z",
  fillRule: "evenodd"
}));

var IconImmersiveReaderLine = /*#__PURE__*/function (_Component) {
  _inherits(IconImmersiveReaderLine, _Component);

  var _super = _createSuper(IconImmersiveReaderLine);

  function IconImmersiveReaderLine() {
    _classCallCheck(this, IconImmersiveReaderLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconImmersiveReaderLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconImmersiveReader",
        viewBox: "0 0 1920 1921"
      }), _ref);
    }
  }]);

  IconImmersiveReaderLine.displayName = "IconImmersiveReaderLine";
  return IconImmersiveReaderLine;
}(Component);

IconImmersiveReaderLine.glyphName = 'immersive-reader';
IconImmersiveReaderLine.variant = 'Line';
IconImmersiveReaderLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconImmersiveReaderLine;
export { IconImmersiveReaderLine };